import React, { useCallback, useEffect, useMemo } from 'react';
import PagesApi from '../PagesApi';

import FieldSelect from '@dex/bubl-dash/src/lib/components/Fields/FieldSelect';
import { Form, useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import Sort from '@dex/bubl-dash/src/lib/components/Sort/Sort';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import { Box } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Loading from '@dex/bubl-dash/src/lib/components/Loading/Loading';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';

const PagesSort: React.FC<any> = (props: any) => {

    const app = useApp();

    const form = useForm();

    const pages = PagesApi.get();

    const save = PagesApi.create({}, "reorder");

    useEffect(() => {

        if (!form.values.section) return;

        const params: any = { where: { section: form.values.section }, include: ["parent"], order: ["order ASC"], limit: 1000 };

        pages.reset();
        pages.cancel();

        pages.run({
            params: params
        });

    }, [form.values.section]);

    const handleSave = useCallback((data) => {

        save.run({
            data: { rows: data },
            onComplete: (response: any) => {

                app.alert(response, 'success');

            }
        });

    }, []);

    return useMemo(() => (

        <Box gutter={"auto"}>

            <Panel
                heading={"Re-Order"}
            >

                <Form
                    form={form}
                >

                    <FieldSelect
                        form={form}
                        label={"Section"}
                        name='section'
                        required={true}
                        defaultValue={form.defaults.section}
                        options={[
                            { value: "about", label: "About" },
                            { value: "userGuide", label: "User Guide" },
                            { value: "other", label: "Other" },
                        ]}
                    />

                </Form>

                {pages.loading &&
                    <Box gutter={"auto"}>
                        <br />
                        <Loading />
                    </Box>
                }

                {pages.data && pages.data.data && pages.data.data.length > 0 &&

                    <Sort
                        data={pages.data.data}
                        parentIdKey={"parentId"}
                        preSorted={false}
                        maxDepth={2}
                        handleSave={handleSave}
                        loading={save.loading}
                    />

                }

            </Panel>

        </Box>

    ), [form.values, pages.loading, save.loading]);

}

export default PagesSort;
